<template>
    <span v-if="isAuthorized">
        <slot></slot>
    </span>
    <div v-else-if="showPermissionMessage">
        <div class="row pt-5">
            <div class="col-12 text-center">
                <h2 class="text-thin">You do not have permission to view this page.</h2>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { useCurrentUserStore } from '@/stores/currentUser.js';

export default {
    props: {
        requireAdmin: Boolean,
        requireRole: Array,
        prismRbsOnly: Boolean,
        showPermissionMessage: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(useCurrentUserStore, ['currentUserHasRole']),
        isAuthorized() {
            if (this.requireAdmin == true) {
                return this.currentUserHasRole('Admin');
            }

            if (this.requireRole) {
                if (this.currentUserHasRole('Admin')) {
                    return true;
                }

                for (let i = 0; i < this.requireRole.length; i++) {
                    if (this.currentUserHasRole(this.requireRole[i])) {
                        return true;
                    }
                }

                return false;
            }

            if (this.prismRbsOnly) {
                return (
                    this.currentUserHasRole('Support') || this.currentUserHasRole('Developer')
                );
            }

            return true;
        }
    }
};
</script>

<style></style>
